import Group from 'components/utils/Group'
import Heading from 'components/Luxkit/Typography/Heading'
import React from 'react'
import BlogCard from 'home/components/Blog/BlogCard'
import CardCarousel from 'components/Luxkit/Carousel/CardCarousel'
import LayoutContainer from 'components/Common/LayoutContainer/LayoutContainer'
import { rem } from 'polished'
import styled from 'styled-components'
import moment from 'moment'

const DreamCarouselContainer = styled(LayoutContainer)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
`

interface Props {
  articles: Array<App.Article>;
}

function DreamCarousel({ articles }: Props) {
  return (
    <>
      {articles &&
        <DreamCarouselContainer>
          <Group direction="vertical" gap={24}>
            <Heading variant="heading3">
              Dream with Luxury Escapes
            </Heading>
            <CardCarousel pageSize={3}>
              {articles.map(article => (
                <BlogCard
                  key={article.slug}
                  imageId={article.imageId}
                  title={article.title}
                  date={moment(article.date)}
                  description={article.description}
                  tags={article.tags}
                  slug={article.slug}
                  lineClamp={2}
                />
              ))}
            </CardCarousel>
          </Group>
        </DreamCarouselContainer>
      }
    </>
  )
}

export default DreamCarousel
